export default __webpack_public_path__ + "media/images/react_icons/user-grey-8b0463298986f8080e394845af3823ac.svg";